import React, { useState, useEffect } from "react";
import "./SociDocuments.scss";
//import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Hero from "../../../common/Hero/Hero";
import moment from "moment";
import { SociFile, SingleSoci } from "../../../common/SociDocument/SociFile";
import FiltersBox from "../../../common/FiltersBox/FiltersBox";
import NoResult from "../../../common/NoResult/NoResult";
import { flatten } from "ramda";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/swiper.scss";

const SociDocuments = () => {
  const { t } = useTranslation();

  const data = [
    {
      id: "1223",
      category: "Assemblea dei soci",
      folders: [
        {
          label: "Assemblea CAP holding",
          date: "2020-12-09T22:00:00Z",
          id: "1a3",
          type: "Assemblea",
          url: "",
          children: [
            {
              label: "Verbale asseblea straordinaria",
              type: "DOCUMENT",
              size: "3",
            },
            {
              label: "Verbale assemblea ordinaria",
              size: "8",
              type: "DOCUMENT",
            },
          ],
        },
        {
          label: "Assemblea CAP holding",
          date: "2017-05-29T22:00:00Z",
          id: "a22",
          type: "Assemblea",
          url: "",
          children: [
            {
              label: "Delega assemblea",
              size: "2",
              type: "DOCUMENT",
            },
            {
              label: "Parte ordinaria .2",
              size: "1",
              type: "DOCUMENT",
            },
          ],
        },
        {
          label: "Assemblea CAP holding",
          date: "2019-01-11T22:00:00",
          id: "312s",
          type: "Assemblea",
          url: "",
          children: [
            {
              label: "Convocazione assemblea",
              size: "2",
              type: "DOCUMENT",
            },
          ],
        },
      ],
    },
    {
      id: "1229",
      category: "comitato di indirizzo strategico",
      typology: [
        {
          label: "test",
          value: "test",
        },
        {
          label: "test 2",
          value: "test 2",
        },
      ],
      folders: [
        {
          label: "Assemblea CAP holding",
          date: "2016-10-12T22:00:00Z",
          id: "1a3s",
          type: "Assemblea",
          url: "",

          children: [
            {
              label: "test",
              type: "DOCUMENT",
              size: "3",
            },
            {
              label: "Verbale assemblea ordinaria",
              size: "8",
              type: "DOCUMENT",
            },
          ],
        },
      ],
    },
    {
      id: "1232",
      category: "bilanci e dati finanziari",
      folders: [],
    },
    {
      id: "1123",
      category: "relazioni e revisioni",
      folders: [],
    },
  ];
  const filterConfigData = {
    fields: [
      {
        name: "search_key",
        type: "input",
        placeholder: t("soci.filter.input.placeholder"),
        leftIcon: "gc-icon-functional-search-1-col",
        columnSize: "4",
      },
      {
        label: t("soci.filter.date.from.label"),
        name: "startD",
        type: "datepicker",
        columnSize: "4",
        placeholder: t("soci.filter.date.from.placeholder"),
        datePickerConfig: {
          datePickerHolderClassName: "picker-1-holder",
          datePickerClassName: "picker-1",
          numberOfColumns: 1,
          numberOfMonths: 1,
          singleMode: true,
          mobileFriendly: true,
          autoApply: false,
          format: "DD-MM-YYYY",
          buttonText: { apply: t("soci.datepicker.buttonText") },
          startDate: null,
          endDate: null,
          placeholder: t("soci.filter.date.from.placeholder"),
        },
      },
      {
        label: t("soci.filter.date2.from.label"),
        name: "endD",
        type: "datepicker",
        columnSize: "4",
        placeholder: t("soci.filter.date2.from.placeholder"),
        datePickerConfig: {
          datePickerHolderClassName: "picker-2-holder",
          datePickerClassName: "picker-2",
          numberOfColumns: 1,
          numberOfMonths: 1,
          singleMode: true,
          mobileFriendly: true,
          autoApply: false,
          format: "DD-MM-YYYY",
          buttonText: { apply: t("soci.datepicker.buttonText") },
          startDate: null,
          endDate: null,
          placeholder: t("soci.filter.date2.from.placeholder"),
        },
      },
    ],
    validations: [],
    configuration: {
      hasReset: true,
    },
  };

  const [key, setKey] = useState(data[0].id);
  const [expand, setExpand] = useState([]);
  const [soci] = useState(data);

  const [filteredSoci, setFilteredSoci] = useState([]);
  const [filterConfig, setFilterConfig] = useState(filterConfigData);

  const [filters, setFilters] = useState({});
  const [modifyFilter, setModifyActiveFilter] = useState("");

  const onFiltersChanged = (e) => {
    if (!e.search_key && !e.startD && !e.endD) {
      setFilters({});
    } else {
      setFilters(e);
    }
  };

  useEffect(() => {
    console.log("EXPAND", expand);
  }, [expand]);

  const ListSoci = () => {
    if (filters && (filters.search_key || filters.startD || filters.endD)) {
      return (
        <div className="container">
          {filteredSoci && filteredSoci.length ? (
            filteredSoci.map((el) => (
              <SingleSoci element={el} title={el.title} />
            ))
          ) : (
            <NoResult text={t("soci.noResults")} />
          )}
        </div>
      );
    }
    let sociObject = soci.find((item) => item.id === key);

    return (
      <>
        {sociObject &&
          sociObject.folders.map((item, index) => {
            return (
              <div className="container">
                <div
                  className={
                    expand === index
                      ? "container container-items-expanded"
                      : "container container-items-document"
                  }
                  key={item.id}
                >
                  <div className="container-soci-item">
                    <p className="text-md-20 font-semi-bold text-style">
                      {item.label +
                        " " +
                        moment(item.date).format("DD MMMM YYYY").toUpperCase()}
                    </p>
                    <p className="text-xs font-light">
                      {item.type.toUpperCase()}
                    </p>
                  </div>
                  {!expand.includes(item.id) ? (
                    <button
                      className="button-icon"
                      onClick={() => {
                        let arrIndex = [...expand];
                        arrIndex.push(item.id);
                        setExpand(arrIndex);
                      }}
                    >
                      <span className="gc-icon-thick-plus"></span>
                    </button>
                  ) : (
                    <button
                      className="button-icon"
                      onClick={() => {
                        let arrIndex = [...expand];
                        arrIndex.splice(arrIndex.indexOf(item.id), 1);
                        setExpand(arrIndex);
                      }}
                    >
                      <span className="gc-icon-thick-minus"></span>
                    </button>
                  )}
                </div>
                {expand.includes(item.id)
                  ? SociFile(item.children, t, item.label)
                  : null}
              </div>
            );
          })}
      </>
    );
  };

  useEffect(() => {
    const target = soci.find((item) => item.id === key);
    if (target && target.typology && target.typology.length) {
      const typologyField = {
        name: "typology",
        type: "select",
        placeholder: t("soci.filter.typology.placeholder"),
        label: t("soci.filter.typology.label"),
        columnSize: "4",
        options: target.typology,
      };
      let prevFilters = filterConfig;
      prevFilters.fields.push(typologyField);
      setFilterConfig(prevFilters);
      setModifyActiveFilter("added-field");
    } else {
      setModifyActiveFilter("");
      setFilterConfig(filterConfigData);
    }
    // eslint-disable-next-line
  }, [key]);

  return (
    <div className="SociDocuments" data-testid="SociDocuments">
      <Hero
        //helpText={t("online.bills.info.title")}
        backTo={"/"}
        backToText={t("page_titles.page.dashboard.title")}
        title={t("soci.header")}
        description={
          <div>
            <p>{t("soci.documents.title")}</p>
            <Link to={"/"}>{t("soci.documents.guarantees")}</Link>
          </div>
        }
      />
      <div className="category-continer">
        <div className="container">
          {/* <Tabs
          defaultActiveKey="profile"
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className={"nav-tabs gcap-tabs-scrollable dragscroll"}
        > */}
          <Swiper
            draggable={true}
            width={255}
            breakpoints={{
              768: {
                touchRatio: 0,
              },
            }}
          >
            {data.map((item) => {
              const active = key === item.id ? "active" : "";
              return (
                <SwiperSlide key={item.id}>
                  <p
                    className={`${active} nav-item`}
                    onClick={() => setKey(item.id)}
                  >
                    {item.category}
                  </p>
                </SwiperSlide>
              );
            })}
            {/* {roleData.map((el: RoleCard, i) => {
                        const active = activeCheckbox === i ? true : false
                    })} */}
          </Swiper>
        </div>

        {/* </Tabs> */}
      </div>
      <div className={modifyFilter}>
        <FiltersBox
          config={filterConfig}
          onChange={onFiltersChanged}
          data={soci}
          onDataFiltered={setFilteredSoci}
          filter={(soci, filters) => {
            const { search_key, startD, endD, typology } = filters;
            if (
              !search_key &&
              (!startD || endD) &&
              (!startD || endD) &&
              (!startD || !endD) &&
              !typology
            ) {
              return soci;
            }

            const sociToFilter = soci.find((item) => item.id === key);
            const sociChildren =
              sociToFilter &&
              sociToFilter.folders &&
              sociToFilter.folders.length > 0
                ? sociToFilter.folders.length > 0
                  ? sociToFilter.folders.map((soci) => {
                      return soci.children.map((sociChildren) => {
                        return {
                          ...sociChildren,
                          title: soci.label,
                          date: soci.date,
                        };
                      });
                    })
                  : []
                : [];

            const flattItems = flatten(sociChildren);

            const searchFilterFn = (item, searchKey) => {
              if (item && searchKey) {
                return (
                  item.label.toLowerCase().includes(searchKey) ||
                  item.title.toLowerCase().includes(searchKey.toLowerCase()) ||
                  item.type.toLowerCase().includes(searchKey.toLowerCase())
                );
              }
              return true;
            };

            const dateRangeFn = (item, date1, date2) => {
              if (item && date1 && date2) {
                const itemDate = new Date(item.date);
                const startDate = new Date(date1.startDate);
                const endDate = new Date(date2.startDate);
                return itemDate >= startDate && itemDate <= endDate;
              }
              return true;
            };

            return flattItems.filter((soco) => {
              return (
                searchFilterFn(soco, search_key) &&
                dateRangeFn(soco, startD, endD)
              );
            });
          }}
        />
      </div>
      {ListSoci()}
    </div>
  );
};

SociDocuments.propTypes = {};

export default SociDocuments;
